export class AssetEmployeeSave {
    id: number;
    invNo: string;
    name: string;
    serialNumber: string;
    info: string;
    info2019: string;
    brandName: string;
    validated: boolean;
    dictionaryItemId: number;
    brandId: number;
    infoPlus: string;
}
